/**
 * Keeps the product facts row (Material, Dimensions, Lead time) in sync with the selected
 * variant. product-info.js fetches the section for the new variant and dispatches
 * `variant:change` with the parsed document; we swap the facts wrapper from it.
 */
if (!window.__pdpFactsRowLoaded) {
  window.__pdpFactsRowLoaded = true;

  document.addEventListener('variant:change', (event) => {
    const { sectionId, html } = event.detail || {};
    if (!sectionId || !html) return;

    const id = `ProductFacts-${sectionId}`;
    const current = document.getElementById(id);
    const updated = html.getElementById ? html.getElementById(id) : html.querySelector(`#${id}`);
    if (!current || !updated) return;

    current.innerHTML = updated.innerHTML;
    current.hidden = updated.hidden;
  });
}
